class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.enableSwipeDrag();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    if (this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.max(1, Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth));
    this.totalPages = Math.max(1, this.sliderItems.length - this.slidesPerPage + 1);
    this.update();
  }

  update() {
    if (this.sliderItems.length === 0) return;

    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.prevButton) {
      if (this.currentPage <= 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.currentPage >= this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    if (this.pageCount && this.pageTotal) {
      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.sliderItems.length === 0) return;

    const slideScrollPosition = event.currentTarget.name === 'next'
      ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
      : this.slider.scrollLeft - this.sliderItems[0].clientWidth;

    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }

  enableSwipeDrag() {
    this.isDown = false;
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.slider.addEventListener('mousedown', this.onDragStart.bind(this));
    this.slider.addEventListener('mousemove', this.onDragMove.bind(this));
    this.slider.addEventListener('mouseup', this.onDragEnd.bind(this));
    this.slider.addEventListener('mouseleave', this.onDragEnd.bind(this));
    this.slider.addEventListener('click', this.preventClickAfterDrag.bind(this), true);
  }

  onDragStart(event) {
    if (event.button !== 0) return;

    this.isDown = true;
    this.isDragging = false;
    this.startX = event.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
  }

  onDragMove(event) {
    if (!this.isDown) return;

    const x = event.pageX - this.slider.offsetLeft;
    const walk = x - this.startX;

    if (Math.abs(walk) > 5) {
      this.isDragging = true;
      this.slider.classList.add('is-dragging');
      event.preventDefault();
      this.slider.scrollLeft = this.scrollLeft - walk;
    }
  }

  onDragEnd() {
    if (!this.isDown) return;

    this.isDown = false;
    window.setTimeout(() => {
      this.slider.classList.remove('is-dragging');
      this.isDragging = false;
    }, 0);
  }

  preventClickAfterDrag(event) {
    if (!this.isDragging) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }
}

customElements.define('slider-component', SliderComponent);
